module.exports = __webpack_public_path__ + "static/media/img12_LV.5309f1ba.png";